module.exports = __webpack_public_path__ + "img/havanna_oak_662m_list.caf5502e.jpg";